import Reveal from "@/components/Reveal";
import { useSeo, pageSeo } from "@/lib/seo";

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`mb-6 flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.28em] text-brand ${className}`}
  >
    <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand" />
    {children}
  </p>
);

export const usePageTitle = (path) => useSeo(pageSeo(path));

const PageHeader = ({ eyebrow, title, lead, testId }) => (
  <section data-testid={testId} className="relative border-b border-white/10 pt-[116px] md:pt-[72px]">
    <div className="mx-auto max-w-[1600px] px-6 pb-20 pt-24 md:px-12 md:pb-28 md:pt-32">
      <Reveal>
        <Eyebrow>{eyebrow}</Eyebrow>
        <h1 className="font-display font-extrabold uppercase leading-[0.9] tracking-tight text-white text-[clamp(3.5rem,13vw,11rem)]">
          {title}
          <span className="text-brand">.</span>
        </h1>
        <p className="mt-8 max-w-2xl text-base leading-relaxed text-white/60 md:text-lg">{lead}</p>
      </Reveal>
    </div>
  </section>
);

export default PageHeader;
